'use strict';

import React, { useState, useEffect, useDebugValue } from 'react';
import { find, get, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';
import ReservationInfo from './ReservationInfo';
import Alert from '../../Alert';
import { APPOINTMENTS } from '../../../data/reducer';
import Loader from '../../Loader';
import {
  resetAppointmentReservation,
  selectReason,
} from '../../../data/appointment/actions';
import { useStateWithLabel } from '../../../utils/DebugUtils';
import MaternityClinicOptions from './MaternityClinicOptions';
import { getTime } from '../../../utils/TimeUtils';
import { MATERNITY_ULTRA_KEY } from '../../../definitions/AppointmentConstants';
import MaternityClinicAlerts from './MaternityClinicAlerts';

const { id: module_id } = module;
const timeNow = getTime();

function ClinicOptions(props) {
  const {
    isFetching,
    data,
    selectedClinicKey,
    history,
    resetAppointmentReservation,
    selectReason,
    existingAppointments,
  } = props;

  const [currentValue, setCurrentValue] = useStateWithLabel('', 'currentValue');
  const [noClinicError, setNoClinicError] = useStateWithLabel(
    null,
    'noClinicError'
  );
  const [noOptionsError, setNoOptionsError] = useStateWithLabel(
    false,
    'noOptionsError'
  );
  const [optionRows, setOptionRows] = useStateWithLabel([], 'optionRows');
  const [buttons, setButtons] = useStateWithLabel([], 'buttons');
  const [selectedClinic, setSelectedClinic] = useStateWithLabel(
    {},
    'selectedClinic'
  );
  const [maternityClinic, setMaternityClinic] = useStateWithLabel(
    false,
    'maternityClinic'
  );
  const [showButtons, setShowButtons] = useStateWithLabel(true, 'showButtons');
  const [dueDate, setDueDate] = useStateWithLabel(
    {
      date: timeNow.date().toString(),
      month: timeNow.month(),
      year: timeNow.year(),
    },
    'dueDate'
  );

  function previous() {
    // does state need to be reset here?

    resetAppointmentReservation();

    history.goBack();

    // reset reservation data a while after navigation, so error is not shown
    setTimeout(resetAppointmentReservation, 1000);
  }

  function next() {
    let option = find(
      selectedClinic.options,
      (option) => selectedClinicKey + '.option.' + option.value === currentValue
    );

    selectReason(option.value, dueDate);

    //history.push(`${match.params.clinicId}/${option.link}`);
  }
  function mapToRowsAndColumns(items, itemsPerRow) {
    let rows = [...Array(Math.ceil(items.length / itemsPerRow))];
    setOptionRows(
      rows.map((row, idx) =>
        items.slice(idx * itemsPerRow, idx * itemsPerRow + itemsPerRow)
      )
    );
  }

  useEffect(() => {
    setSelectedClinic(find(data, (option) => option.key === selectedClinicKey));
    setMaternityClinic(selectedClinicKey.toString() === MATERNITY_ULTRA_KEY);

    if (!selectedClinic) {
      setNoClinicError(<Alert message={`${module_id}.clinic.not.found`} />);
    } else {
      if (selectedClinic.options) {
        mapToRowsAndColumns(selectedClinic.options, 2);
      }
    }
  }, [selectedClinic]);

  useEffect(() => {
    setButtons([
      <OTButton
        key="back"
        message={'back'}
        color={'gray'}
        onClick={() => previous()}
      />,
      <OTButton
        key="continue.to.reservation"
        disabled={!currentValue}
        message={'continue.to.reservation'}
        onClick={() => next()}
      />,
    ]);
  }, [currentValue]);

  function handleRadioChange(event) {
    setCurrentValue(event.target.value);
  }

  return (
    <>
      {isFetching ? (
        <Loader />
      ) : (
        !isEmpty(selectedClinic) && (
          <div className="ot-mainview">
            <h1>
              <FormattedMessage id={`${module_id}.title`} />
            </h1>

            {maternityClinic && (
              <MaternityClinicAlerts
                existingAppointments={existingAppointments}
              />
            )}

            <h2 className={'subheading-gray'}>
              <FormattedMessage id={`${module_id}.available.times`} />
            </h2>

            {noClinicError || (
              <div className="appointment-container">
                <div className={'appointment'} style={{ width: '100%' }}>
                  <Row>
                    <Span len="12" sm-len="12">
                      <FormattedMessage id={selectedClinic.key + '.location'} />
                    </Span>
                  </Row>
                  {get(data, 'meta', null) !== null && (
                    <Row>
                      <Span len="12" sm-len="12">
                        <ReservationInfo data={selectedClinic} />
                      </Span>
                    </Row>
                  )}
                </div>
              </div>
            )}
            {!noClinicError && (
              <>
                {maternityClinic ? (
                  <MaternityClinicOptions
                    currentValue={currentValue}
                    setCurrentValue={setCurrentValue}
                    selectedClinicKey={selectedClinicKey}
                    selectedClinic={selectedClinic}
                    optionRows={optionRows}
                    dueDate={dueDate}
                    setDueDate={setDueDate}
                    headerId={`${module_id}.pick.appointment.reason`}
                    existingAppointments={existingAppointments}
                  />
                ) : (
                  <form className="ot-form">
                    <h2 className={'subheading-gray required'}>
                      <FormattedMessage
                        id={`${module_id}.pick.appointment.reason`}
                      />
                    </h2>
                    {!selectedClinic.options ? (
                      <Alert message={`${module_id}.options.not.found`} />
                    ) : (
                      optionRows.map((row, idx) => (
                        <Row key={idx} style={{ marginTop: '10px' }}>
                          {row.map((option, optionIdx) => {
                            let key =
                              selectedClinic.key + '.option.' + option.value;
                            return (
                              <div key={key}>
                                <Span len={6} key={key}>
                                  <label
                                    htmlFor={key}
                                    style={{ position: 'relative' }}
                                  >
                                    <input
                                      type="radio"
                                      id={key}
                                      name={''}
                                      value={key}
                                      style={{ marginTop: '-2px' }}
                                      checked={currentValue.toString() === key}
                                      onChange={(event) =>
                                        handleRadioChange(event)
                                      }
                                    />
                                    <span
                                      className="radio-check"
                                      style={{ marginTop: '2px' }}
                                    />
                                    <span className="radio-label radio-label-black">
                                      <FormattedMessage id={key} />
                                    </span>
                                  </label>
                                </Span>
                              </div>
                            );
                          })}
                        </Row>
                      ))
                    )}
                  </form>
                )}
              </>
            )}

            {showButtons && (
              <Row>
                <Span>
                  <OTButtonGroup
                    type="big"
                    fullWidth
                    collapseOnMobile
                    expectedCount={2}
                  >
                    {buttons}
                  </OTButtonGroup>
                </Span>
              </Row>
            )}
          </div>
        )
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  const { isFetching, data, error, selectedClinicKey } =
    state[APPOINTMENTS].reservation.clinics;
  const { data: existingAppointments } = state[APPOINTMENTS].appointments;

  return {
    selectedClinicKey,
    isFetching,
    data,
    error,
    existingAppointments,
  };
};

export default withRouter(
  connect(mapStateToProps, { selectReason, resetAppointmentReservation })(
    ClinicOptions
  )
);
